import MobileNav from '../components/MobileNav';
import React, { useState } from 'react';
import logo from '../assets/images/wordb_logo.svg'
import Feedback from '../components/Feedback';
import Query from '../components/Query';
//import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { BiHome } from "react-icons/bi";
import { Helmet } from "react-helmet-async";

const Help = () => {
      const [isFeedbackOpen, setFeedbackOpen] = useState(false);
      const [isQueryOpen, setQueryOpen] = useState(false);
      const toggleFeedback = () => setFeedbackOpen(open => !open);
      const toggleQuery = () => setQueryOpen(open => !open);


  return (
    <>
      <Helmet>
        <title>How to Play WordB — Rules & Tips</title>
        <meta
          name="description"
          content="Learn how to play WordB, understand the rules, and start winning multiplayer word battles."
        />
      </Helmet>
      <section className='help-page info'>


        {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
        {isQueryOpen && <Query onClose={toggleQuery} />}

        <Link to="/home" className='left-icon-link'>
          <BiHome className='icon' />
        </Link>

        <MobileNav />


        <div className="info-container">

          <div className="logo-div">
              <img src={logo} alt="" />
          </div>
          
          <p className="info-h2">How to Play</p>
          <p className="txt">
            Welcome to WordB, the fast-paced word chain challenge where every letter, and every second, counts!
          </p>



          <p className="info-h3">The Goal</p>
          <p className="txt">
            Keep the chain alive by creating valid English words that start with the last letter of the previous word.
            The longer your word, the higher your score. But remember, the clock is always ticking!
          </p>

          <div className="gif-box-2">
            <video
              autoPlay
              muted
              loop
              playsInline
              preload="none"
              poster="/assets/images/how-to-play.webm"
            >
              <source src="/assets/images/how-to-play.mp4" type="video/mp4" />
            </video>
          </div>

          <p className="info-h3">Game Modes</p>
          <p className="txt">
            <span>Solo:</span> Perfect for practice or a quick challenge.
            <br />
            <span>Multiplayer:</span> Go head-to-head with friends or other players in real-time.
            <br />
          </p>

          <p className="info-h3">Game Rules</p>
          <p className="txt">
            <span>1. Use the Last Letter</span> - 
            When it’s your turn, look at the last letter of the word on the screen.
            Type a new word that begins with that letter.
            <br />

            <span>2. No Repeats</span> - 
            Each word can only be used once per match.
            <br />

            <span>3. Word Length Limit</span> -
            Only words with 10 letters or fewer are allowed.
            The longer your word, the higher you score.
            <br />

            
            <span>4. Beat the Clock</span> -
            As the game progresses, the timer gets shorter, forcing you to think and type faster.
            If the timer hits zero before you enter a valid word, you’re out!
            <br />
          </p>

        </div>
        
        <div className="footer-landing">
          <p className="opens-modal feedback-cta" onClick={toggleFeedback}>Make this game better. Share your thoughts here</p>
          <p className="opens-modal help-cta" onClick={toggleQuery}>Need help? Reach out to us here</p>
        </div>
      </section>

    </>
  )
}

export default Help